module.exports = __webpack_public_path__ + "img/soccer.21dfe28e.svg";